var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 87 87"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.75,
    cy: 43.5,
    r: 43,
    fill: "#1F2D3D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7B848F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.75 59.5a32.8 32.8 0 0 1-12.406-2.086 1 1 0 0 1-.594-.914 10.01 10.01 0 0 1 10-10h6a10.01 10.01 0 0 1 10 10 1 1 0 0 1-.594.914A32.8 32.8 0 0 1 43.75 59.5M43.75 44.5c-4.579 0-8-4.751-8-9a8 8 0 0 1 16 0c0 4.249-3.421 9-8 9"
  }))));
};
export default SvgAvatar;